import Header from "../../header/header";
import "./page.css"

export function Planpage() {
    return (
        <body>
  
        <div id="top">
          <Header />
          <section class="py-5 text-center ">
            <div class="py-lg-5">
              <div class="col-lg-6 col-md-8 mx-auto">
                <h1 class="title display-1" >計畫</h1>
              </div>
            </div>
          </section>
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 " id="med">醫療領域產學合作計畫</p>
                <p class="content mt-md-5 px-md-3">1.	111年科技部專題研究計畫(一般研究計畫)，肝細胞癌精準醫療策略和預後評估整合平台：建構臨床資料庫、基因體學、 影像體學和病理體學資訊網絡(2/4)，共同主持人，111-2321-B-182A-003 -，2022/05/01~2023/04/30，合作單位：長庚醫療財團法人一般外科。</p>
                <p class="content mt-md-5 px-md-3">2.	111年長正計畫，人工智慧深度學習於肺癌：電腦斷層偵測,診斷,治療之預測應用，合作廠商：高雄長庚醫院／放射診斷科，正研產學字(111)第105號，111.03.01~111.11.30。</p>
                <p class="content mt-md-5 px-md-3">3.	110年科技部專題研究計畫(一般研究計畫)，肝細胞癌精準醫療策略和預後評估整合平台：建構臨床資料庫、基因體學、 影像體學和病理體學資訊網絡(1/4)，共同主持人，110-2321-B-182A-003 -，2021/05/01~2022/04/30，合作單位：長庚醫療財團法人一般外科。</p>
                <p class="content mt-md-5 px-md-3">4.	利用人工智慧技術於肢端黑色素細胞癌診斷與衛教，合作廠商：高雄長庚醫院／皮膚科，正修科技大學高教深耕110年度籌組大數據分析預測聯盟計畫，110.04.01~110.12.31。</p>
                <p class="content mt-md-5 px-md-3">5.	利用資料探勘於急性腎損傷(AKI) 風險預測評估模式之建立，合作廠商：高雄長庚醫院／腎臟科 (206M-110D213)，正修科技大學高教深耕110年度籌組大數據分析預測聯盟計畫，110.04.01~110.12.31。</p>
                <p class="content mt-md-5 px-md-3">6.	正修科技大學高教深耕110年度長正產學研究計畫(206M-110D221)，利用人工智慧技術於舟狀骨骨折診斷，治療與預後，正研產學字(110)第116號，合作廠商：高雄長庚醫院／放射診斷科，共同主持人，110.01.01~110.12.31。</p>
                <p class="content mt-md-5 px-md-3">7.	正修科技大學高教深耕110年度長正產學研究計畫，人工智慧整合性肝癌結構式報告系統，正研產學字(110)第117號，合作廠商：高雄長庚醫院／放射診斷科，共同主持人，110.01.01~110.12.31。</p>
                <p class="content mt-md-5 px-md-3">8.	正修科技大學高教深耕109年度長正產學研究計畫，智慧化影像診斷報告轉譯系統 (Artificial Intelligent Translation System for Image Reports) (206M-109D221)，合作廠商：高雄長庚醫院，共同主持人，109.1.1-109.12.31。</p>
                <p class="content mt-md-5 px-md-3">9.	正修科技大學高教深耕108年度產學新技研計畫，健康檢測穿戴裝置原型開發與皮膚疾病預測平台建置(206H-109D221)，主持人，109.4.1~109.12.31。</p>
                <p class="content mt-md-5 px-md-3">10.	正修科技大學高教深耕108年度產學新技研計畫，智慧化影像診斷報告轉譯系統，正研產學字(108)第353號，合作廠商：高雄長庚醫院，共同主持人，108.4.1~108.12.31。</p>
              </div>
  
            </div>
  
          </div>
          
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="eduction">教育部教學實踐計畫</p>
                <p class="content mt-md-5 px-md-3">1.	110年度教育部教學實踐計畫，運用「同儕協助與競賽目標導向學習」之創新模式探討技職學生「資料探勘應用」課程中不同人格特質學習者之學習情緒、學習情境壓力、學習動機、吸收能力與學習成效之差異 (PBM1101091)，商業及管理類別，計畫主持人，110.08.1~111.7.31。</p>
                <p class="content mt-md-5 px-md-3">2.	109年度教育部教學實踐計畫，運用素養導向教育、設計服務流程、新領人才教育模式探討技職大學生物聯網程式設計課程中情緒調整與自我調節學習策略對學業歷程與學習成就之關係 (PBM1090545)，商業及管理類別，計畫主持人，109.08.1~110.7.31，金額：0。</p>
                <p class="content mt-md-5 px-md-3">3.	108年度教育部教學實踐計畫，結合趣創者及PBL之程式設計教學於商管學群學生之研究 (PBM1080236)，商業及管理類別，計畫主持人， 108.08.1~109.7.31，金額：204,000。</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="country">國科會專題研究計畫</p>
                <p class="content mt-md-5 px-md-3">1.	111年科技部一般型計畫，科普活動：刻劃「藝陣之鄉」，科學內門逍遙遊，cubio 酷斃了(主題三) (NSTC 111-2515-S-230 -001 -)，計畫主持人，金額：800,000，111.08.1~112.07.31。</p>
                <p class="content mt-md-5 px-md-3">2.	111年科技部一般型計畫，「碳為觀止」從系統變革觀點與議題情境模擬遊戲建構氣候變遷素養：以技專校院「氣候變遷永續教育」課程為例 (NSTC 111-2410-H-230 -003 -MY2)，計畫主持人，金額：1,752,000，111.08.1~112.07.31。</p>
                <p class="content mt-md-5 px-md-3">3.	111年科技部生科司健康大數據永續平台計畫(一般研究計畫)，肝細胞癌精準醫療策略和預後評估整合平台：建構臨床資料庫、基因體學、 影像體學和病理體學資訊網絡(2/4)，共同主持人-，2022/05/01~2023/04/30，金額：10,000,000，合作單位：長庚醫療財團法人。</p>
                <p class="content mt-md-5 px-md-3">4.	110年科技部生科司健康大數據永續平台計畫(一般研究計畫)，肝細胞癌精準醫療策略和預後評估整合平台：建構臨床資料庫、基因體學、 影像體學和病理體學資訊網絡(1/4)，共同主持人，110-2321-B-182A-003 -，2021/05/01~2022/04/30，合作單位：長庚醫療財團法人。</p>
                <p class="content mt-md-5 px-md-3">5.	109年科技部一般型計畫，基於人工智慧之情境行為感知大數據探勘於教育上之分析應用 (MOST 109-2511-H-230 -001 -MY2)，計畫主持人，109.08.1~111.07.31。</p>
                <p class="content mt-md-5 px-md-3">6.	108年科技部一般型計畫，結合Double-PBL-STEAM教育科學活動與大數據資料探勘推薦技術應用於女性科技人才之培育 (MOST 108-2629-H-230 -001 -)，計畫主持人，108.08.1~109.7.31。</p>
                <p class="content mt-md-5 px-md-3">7.	107年科技部一般型計畫，機器人程式設計教育與STEAM科技人才培育之研究： 融入群眾外包知識分享概念與科技內容教學知識評估模式 (MOST 107-2511-H-230 -003 -MY2)，計畫主持人，107.08.1~109.7.31。</p>
                <p class="content mt-md-5 px-md-3">8.	107年科技部一般型計畫，積木導向物聯網生活科技應用教學模組發展與設計 (MOST 107-2511-H-230 -002 -)，計畫主持人，107.08.1~108.7.31。</p>
                <p class="content mt-md-5 px-md-3">9.	106年科技部一般型計畫，結合擴增實境教育與空氣品質監測平台探究空氣汙染環境教育學習與應用：以促進社會環境改變 (MOST 106-2511-S-230 -001 -)，計畫主持人，106.08.1~107.7.31。</p>
                <p class="content mt-md-5 px-md-3">10.	105年科技部一般型計畫，空氣汙染即時監測警報系統建構健康舒適的安全生活 (MOST 105-3011-F-041 -001 -)，計畫主持人，105.07.1~106.6.30。</p>
                <p class="content mt-md-5 px-md-3">11.	104年科技部一般型計畫，探討競爭式協同學習對技專校院學生程式設計學習能力之影響  (MOST 104-2511-S-041 -001 -MY2)，計畫主持人，104.08.1~106.7.31。</p>
                <p class="content mt-md-5 px-md-3">12.	103年科技部產學合作計畫，結合雲端科技與農業應用－聯利植物連鎖醫院之農作物栽種整合APP平台 (MOST 103-2622-H-041-001 -CC3)，計畫主持人，103.11.1~104.10.31。</p>
                <p class="content mt-md-5 px-md-3">13.	102年科技部一般型計畫，智慧型手機品牌忠誠模式：具吸引力替代方案可得性之調節角色 (NSC 102-2410-H-041 -003)，計畫主持人，102.08.1~103.7.31。</p>
                <p class="content mt-md-5 px-md-3">14.	101年科技部產學合作計畫，以社群網站為基礎具推薦機制之故事電子繪本合作學習平台 (NSC 101-2622-S-041-001-CC3)，計畫主持人，101.11.1~102.10.31。</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="tech">科技部大專生專題研究計畫</p>
                <p class="content mt-md-5 px-md-3">1.	110年度科技部大專學生專題研究計畫，學生：曾弘宇，基於影像辨識及腦波情境感知之音樂推薦平台 (MOST 110-2813-C-230-003-H)，指導老師，110.07.1~111.02.28。</p>
                <p class="content mt-md-5 px-md-3">2.	109年度科技部大專學生專題研究計畫，學生：陳姿妤，基於大數據資料分析技術之專長比對系統 (109-2813-C-230 -003–H)，指導老師，109.07.1~110.02.28。</p>
                <p class="content mt-md-5 px-md-3">3.	108年度科技部大專學生專題研究計畫，學生：許家蓁，大數據資料探勘之智慧媒合服務平台 (MOST 108-2813-C-230-002-H)，指導老師，108.07.1~109.02.28。</p>
                <p class="content mt-md-5 px-md-3">4.	107年度科技部大專學生專題研究計畫，學生：鄭玉琳，口腔保健，遠離齲齒掌握刷牙藝術：結合物聯網及電子書之智能牙齒保健實驗教具平台 (MOST 107-2813-C-230-004-H)，指導老師，107.07.1~108.02.28。</p>
                <p class="content mt-md-5 px-md-3">5.	106年度科技部大專學生專題研究計畫，學生：劉建緯，居家遠端節能防災監控系統 (MOST 105-2815-C-230-005-H)，指導老師，106.07.1~107.02.28。</p>
                <p class="content mt-md-5 px-md-3">6.	105年度科技部大專學生專題研究計畫，健康氣象觀測站APP設計及使用行為評估 (MOST 105-2815-C-041-017-U)，指導老師，105.07.1~106.02.28。</p>
                <p class="content mt-md-5 px-md-3">7.	104年度科技部大專學生專題研究計畫，點名小幫手APP平台開發與教師使用行為評估 (NSC 104-2815-C-041-005-U)，指導老師，104.07.1~105.02.28。</p>
                <p class="content mt-md-5 px-md-3">8.	103年度科技部大專學生專題研究計畫，健康管理APP平台開發與使用行為評估(NSC 103-2815-C-041-004-H)，指導老師，103.07.1~104.02.28。</p>
                <p class="content mt-md-5 px-md-3">9.	102年度科技部大專學生專題研究計畫，結合Facebook之雲端學習平台建置與評估(NSC 102-2815-C-041-009-S)，指導老師，102.07.1~103.02.28。</p>
                <p class="content mt-md-5 px-md-3">10.	102年度科技部大專學生專題研究計畫，360度蕾絲產品瀏覽及試穿效果檢視平台(NSC 102-2815-C-041-004-H)，指導老師，102.07.1~103.02.28。</p>
                <p class="content mt-md-5 px-md-3">11.	101年度科技部大專學生專題研究計畫，走過2D時代，開創3D未來，攜手打造幸福空間(NSC 101-2815-C-041-001-H)，指導老師，101.07.1~102.02.28。</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="innovation">創業計畫、資訊志工及教學翻轉計畫</p>
                <p class="content mt-md-5 px-md-3">1.	111年度正修科技大學獎勵師生及校友創業計畫，想享力社會企業，指導老師， 111.05.1~111.11.30 (第一名/獲高雄市青年局及正修科技大學補助)。</p>
                <p class="content mt-md-5 px-md-3">2.	104年度教育部資訊志工團隊計畫，團隊名稱：嘉藥資管一級棒，服務對象：高雄市-六龜DOC及市立寶來國中 (104087)，教育部，計畫主持人，104.07.15 ~ 105.05.31.</p>
                <p class="content mt-md-5 px-md-3">3.	104年「鼓勵大專校院帶動高中職、國中小學辦理服務學習攜手計畫 」，教育部青年發展署補助「帶動高中職以下學校辦理服務學習攜手計畫」，創意數位資訊應用與行動學習，104/03/01~104/09/30</p>
                <p class="content mt-md-5 px-md-3">4.	教育部104年度翻轉式協同教學課程，軟體工程協同教學計劃，計畫主持人，105.09.1~105.12.31。</p>
                <p class="content mt-md-5 px-md-3">5.	教育部資科司軟體人才培育計畫-「軟體工程推廣」到校協同教學，種子教師：李信杰老師，104.11.15~104.12.31.</p>
                <p class="content mt-md-5 px-md-3">6.	教育部資科司軟體人才培育計畫-「軟體工程推廣」到校協同教學，種子教師：李俊宏老師，102.11.23~102.12.28.</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="job">就業學程及產業學院計畫</p>
                <p class="content mt-md-5 px-md-3">1.	產學合作計畫，高雄旅遊網站系統之建置，正研產學字 (110) 第 040號主持人，110.03.01 ~ 110.08.31。</p>
                <p class="content mt-md-5 px-md-3">2.	吳錦昂、李詠騏、夏自立、廖奕雯，智慧物聯網創新應用學程計畫，108正研產學字(108)第384號，政府產學計畫，2020/07/01 ~ 2021/08/31。</p>
                <p class="content mt-md-5 px-md-3">3.	產學合作計畫，人工智慧應用於智慧新零售服務設計與創新應用，正研產學字 (107) 第 400號，主持人，108.05.01 ~ 108.10.31。</p>
                <p class="content mt-md-5 px-md-3">4.	106學年度就業學程計劃，物聯網架構下行動創新應用實務學程，林哲宏,陳玉珠,夏自立,李春雄,李詠騏,廖奕雯，正研產學字(105)第362號，協同主持人，106.07.01 ~ 107.06.30。</p>
                <p class="content mt-md-5 px-md-3">5.	勞動部勞動力發展署，103學年補助大專校院辦理就業學程計畫，創意數位電子書設計及製作學程，協同主持人，103.08.01~104.07.31.</p>
                <p class="content mt-md-5 px-md-3">6.	勞動部勞動力發展署，102學年補助大專校院辦理就業學程計畫，創意數位學習設計及製作學程，計畫主持人，102.08.01~103.07.31.</p>
                <p class="content mt-md-5 px-md-3">7.	教育部補助科技大學及技術學院辦理產業學院計畫，103學年度產業學院契合式人才培育專班計畫，流行精品鑑定與網路行銷學分學程，協同主持人，103.08.01~105.07.31.</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 "id="goverment">政府及學校單位計畫</p>
                <p class="content mt-md-5 px-md-3">1.	102年度臺南市政府地方產業創新研發推動計畫(102QF3) -健康自主管理服務行銷模式，康原國際有限公司，協同主持人，102.08.01~103.04.30。</p>
                <p class="content mt-md-5 px-md-3">2.	嘉南藥理大學校內計畫，發展雲端化感測技術之電子書學習環境-以電子書探討不同性質學習者在合作學習情境中對學習成效之影響 (CN10224)，計畫主持人，102.06.10~102.11.30.</p>
                <p class="content mt-md-5 px-md-3">3.	嘉南藥理大學校內計畫，以顧客基礎觀點探討網路經濟環境之網站品牌權益衡量模式 (CN10128)，計畫主持人，101.06.25~101.11.30</p>
                <p class="content mt-md-5 px-md-3">4.	嘉南藥理大學校內計畫，數位學習環境中學生持續使用企業模擬遊戲影響因素之研究(CN10022)，計畫主持人，100.06.25~100.11.30</p>

  
              </div>
  
            </div>
  
          </div>
         
        </div>
        <div class="text-center" id="MyBlog">
        <p><a  href="#top">回頂部</a></p>
        <p><a  href="#med">醫療領域產學</a></p>
        <p><a  href="#eduction">教育部教學</a></p>
        <p><a  href="#country">國科會專題</a></p>
        <p><a  href="#tech">科技部大專生專題</a></p>
        <p><a  href="#innovation">創業計畫、資訊志工</a></p>
        <p><a  href="#job">就業學程及產業學院</a></p>
        <a  href="#goverment">政府及學校單位</a>
      </div>
        <div class="aa"></div>
      </body>
  
    );
  }